<!--
 * @Author: 陈大仙人
 * @Date: 2023-08-03 09:49:33
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2024-01-10 18:13:04
 * @FilePath: /akx-pc-main/src/login/components/page-container.vue
-->
<template>
	<div class="main-app-container">
		<div class="container">
			<img src="../assets/bg-new.png" class="img" alt />
			<div class="container-item">
				<div class="form-area">
					<div class="form">
						<slot> </slot>
					</div>
					<div class="form-footer" v-if="$slots.formFooter">
						<slot name="formFooter"></slot>
					</div>
				</div>
				<p class="f-s-12 f-c-99" style="margin-top: 14px; text-align: center;">copyright© 2018-{{new Date().getFullYear()}}.布谷云软件技术(南京)有限公司<span style="margin-left: 10px;"></span>联系电话：400-166-9695</p>
			</div>
			<div class="container-banner" v-for="(item, index) in adList" :key="index" @click="jump(index)">
				<img :src="item.banner" alt="">
			</div>
		</div>
		<slot name="footer"></slot>
	</div>
</template>

<script>
import adList from '../ad'
export default {
	name: 'PageContainer',
	data() {
		return {
			adList
		}
	},
	methods: {
		jump(index) {
			const page = this.$router.resolve({
        name: 'Ad',
				query: {
					index: index,
				},
      });
      window.open(page.href, '_blank');
		},
	},
};
</script>

<style scoped lang="scss">
.main-app-container {
	position: relative;
	width: 100%;
	height: 100%;
	background-color: #f0f0f0;
	.container {
		width: 1200px;
		height: 622px;
		transform: translate(-50%, -50%);
		position: absolute;
		top: 50%;
		left: 50%;

		.img {
			width: 591px;
			display: block;
		}

		.container-item {
			position: absolute;
			right: 0;
			top: 0;
		}
	}
	.form-area {
		width: 480px;
		background-color: #ffffff;
		box-shadow: 0 8px 24px 0 #f0e8e8;
		.form {
			padding-left: 60px;
			padding-right: 60px;
			padding-top: 38px;
		}
	}
	.form-footer {
		width: 480px;
		height: 62px;
		background: #f8f8f8;
		line-height: 62px;
		text-align: center;
		font-size: 20px;
		color: #999999;
		box-shadow: 0px 8px 24px 0px rgba(240, 232, 232, 0.79);
	}

	.container-banner {
		cursor: pointer;
		margin-top: 10px;
		display: inline-block;
	}

	.container-banner > img {
		height: 36px;
	}

	.container-banner ~ .container-banner {
		margin-left: 20px;
	}
}
</style>
